import { WSBadge } from "@wingspanhq/fe-component-library";
import { Form1099Status } from "@wingspanhq/payments/dist/interfaces";
import React from "react";

import styles from "./styles.module.scss";

export interface FilingStatusProps {
  status: Form1099Status;
}

const statusToDisplayStatusMap = {
  [Form1099Status.Accepted]: Form1099Status.Accepted,
  [Form1099Status.Excluded]: Form1099Status.Excluded,
  [Form1099Status.NeedsActionInfo]: "Needs action",
  [Form1099Status.NeedsActionDispute]: "Needs action",
  [Form1099Status.Ready]: Form1099Status.Ready,
  [Form1099Status.Rejected]: Form1099Status.Rejected,
  [Form1099Status.Submitted]: Form1099Status.Submitted
};

export const TaxFormStatusBadge: React.FC<FilingStatusProps> = ({ status }) => {
  switch (status) {
    case Form1099Status.NeedsActionInfo:
    case Form1099Status.NeedsActionDispute:
      return (
        <WSBadge
          className={styles.badge}
          backgroundColor="yellow100"
          textProps={{
            color: "yellow500"
          }}
          leftIcon={{
            mr: "XS",
            name: "danger",
            color: "yellow500"
          }}
          text={statusToDisplayStatusMap[status]}
        />
      );
    case Form1099Status.Ready:
      return (
        <WSBadge
          className={styles.badge}
          backgroundColor="blue100"
          textProps={{
            color: "blue500"
          }}
          text={statusToDisplayStatusMap[status]}
        />
      );
    case Form1099Status.Excluded:
      return (
        <WSBadge
          className={styles.badge}
          backgroundColor="grey200"
          textProps={{
            color: "grey700"
          }}
          text={statusToDisplayStatusMap[status]}
        />
      );
    case Form1099Status.Submitted:
    case Form1099Status.Accepted:
    case Form1099Status.Rejected:
    default:
      return (
        <WSBadge
          className={styles.badge}
          text={statusToDisplayStatusMap[status]}
        />
      );
  }
};
